function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_3102_15737)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12 1.75C6.33908 1.75 1.75 6.33908 1.75 12C1.75 17.6609 6.33908 22.25 12 22.25C16.0787 22.25 19.6025 19.8677 21.2531 16.4153C21.4318 16.0416 21.8795 15.8835 22.2532 16.0622C22.6269 16.2408 22.7851 16.6886 22.6064 17.0623C20.7161 21.0162 16.678 23.75 12 23.75C5.51065 23.75 0.25 18.4893 0.25 12C0.25 5.51065 5.51065 0.25 12 0.25C16.5672 0.25 20.5245 2.85596 22.4684 6.65862C22.6569 7.02744 22.5108 7.47927 22.142 7.6678C21.7731 7.85634 21.3213 7.7102 21.1328 7.34138C19.4353 4.02068 15.9822 1.75 12 1.75Z",
  fill: "#242221"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M22.7244 7.64358C22.6172 8.04368 22.206 8.28112 21.8059 8.17391L17.9422 7.13864C17.5421 7.03143 17.3047 6.62018 17.4119 6.22008C17.5191 5.81998 17.9303 5.58254 18.3304 5.68975L21.4697 6.53091L22.3108 3.39165C22.418 2.99155 22.8293 2.75411 23.2294 2.86132C23.6295 2.96853 23.8669 3.37978 23.7597 3.77988L22.7244 7.64358Z",
  fill: "#242221"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.58971 8.75211C8.41033 8.75211 8.26492 8.89752 8.26492 9.0769V15.8975C8.26492 16.0769 8.41033 16.2223 8.58971 16.2223H15.4103C15.5897 16.2223 15.7351 16.0769 15.7351 15.8975V9.0769C15.7351 8.89752 15.5897 8.75211 15.4103 8.75211H8.58971ZM6.96576 9.0769C6.96576 8.18001 7.69283 7.45295 8.58971 7.45295H15.4103C16.3072 7.45295 17.0342 8.18001 17.0342 9.0769V15.8975C17.0342 16.7944 16.3072 17.5214 15.4103 17.5214H8.58971C7.69283 17.5214 6.96576 16.7944 6.96576 15.8975V9.0769Z",
  fill: "#242221"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.9487 6.47858C14.3075 6.47858 14.5983 6.7694 14.5983 7.12816V9.0769C14.5983 9.43565 14.3075 9.72648 13.9487 9.72648C13.59 9.72648 13.2992 9.43565 13.2992 9.0769V7.12816C13.2992 6.7694 13.59 6.47858 13.9487 6.47858Z",
  fill: "#242221"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.0513 6.47858C10.41 6.47858 10.7008 6.7694 10.7008 7.12816V9.0769C10.7008 9.43565 10.41 9.72648 10.0513 9.72648C9.69251 9.72648 9.40168 9.43565 9.40168 9.0769V7.12816C9.40168 6.7694 9.69251 6.47858 10.0513 6.47858Z",
  fill: "#242221"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.96576 11.0256C6.96576 10.6669 7.25659 10.3761 7.61534 10.3761H16.3847C16.7434 10.3761 17.0342 10.6669 17.0342 11.0256C17.0342 11.3844 16.7434 11.6752 16.3847 11.6752H7.61534C7.25659 11.6752 6.96576 11.3844 6.96576 11.0256Z",
  fill: "#242221"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_3102_15737"
}, /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  fill: "white"
})));

function SvgSentThisMonth(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSentThisMonth);
export default __webpack_public_path__ + "static/media/sent-this-month.1787e4d3.svg";
export { ForwardRef as ReactComponent };